var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"title"},[_c('h1',[_vm._v(" Brand New Arrivals ")]),_c('h4',[_vm._v(" NEW COLLECTION FROM NEW YORK ")]),_c('Button',{attrs:{"text":_vm.leftButton}}),_c('Button',{attrs:{"text":_vm.rightButton}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }